import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "../components/layout/Sidebar";
import { Header } from "../components/layout/Header";

/**
 * 管理画面の全体レイアウト
 * 左: Sidebar / 右上: Header / 右本体: Outlet (各ページ)
 */
export const AdminLayout = () => {
  const location = useLocation();
  const instagramV2Layout = location.pathname === "/instagram-v2";
  const mailV2Layout = location.pathname === "/mail-v2";
  const wideLayout = instagramV2Layout || mailV2Layout || location.pathname === "/analytics" || location.pathname === "/google-business";

  return (
    <div className="admin-shell">
      <Sidebar />
      <div
        className={`admin-main ${wideLayout ? "admin-main--wide" : ""} ${instagramV2Layout ? "admin-main--instagram-v2" : ""} ${
          mailV2Layout ? "admin-main--mail-v2" : ""
        }`}
      >
        <Header />
        <main
          className={`admin-content ${instagramV2Layout ? "admin-content--instagram-v2" : ""} ${
            mailV2Layout ? "admin-content--mail-v2" : ""
          }`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};
